(function () {
  var DURATION = 1500;

  function animate(el) {
    var target = parseInt(el.dataset.target, 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      el.textContent = target + '%';
      return;
    }
    var start = null;
    function frame(time) {
      if (start === null) start = time;
      var progress = Math.min((time - start) / DURATION, 1);
      el.textContent = Math.floor(progress * target) + '%';
      if (progress < 1) {
        window.requestAnimationFrame(frame);
      } else {
        el.textContent = target + '%';
      }
    }
    el.textContent = '0%';
    window.requestAnimationFrame(frame);
  }

  function initCounter(root) {
    if (!root || root.dataset.customCounterReady) return;
    root.dataset.customCounterReady = 'true';
    var numbers = root.querySelectorAll('[data-counter]');
    if (!numbers.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animate(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    numbers.forEach(function (number) {
      observer.observe(number);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-counter]').forEach(initCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCounter(event.target.querySelector('[data-custom-counter]'));
  });
})();